import {
  Box,
  Button,
  ClickAwayListener,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  Popper,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react';
import retrexlogo from 'assets/icons/retrexlogo.png';
import successgif from 'assets/gifs/successgif.gif';
import {
  ADD_PROPERTY_TYPELIST,
  BUYER_GETQUESTION,
  BUYER_SAVEQUESTION,
} from 'constant/app.config';
import { getApiCall, postApiCall } from 'api/apiService';
import { datacontext } from 'modules/AppLayout/AppLayout';
import {
  Acreage,
  AlwaysActive,
  ApartmentUnit,
  BlockOfApartments,
  CalendarIcon,
  CancelBtn,
  CancelBtnMobile,
  Company,
  Downsize,
  FamilyChange,
  FirstHome,
  Floorplan,
  FollowUpBank,
  Friend,
  House,
  Land,
  Location,
  Relative,
  RetirementLiving,
  Rural,
  SelectIcon,
  Self,
  SuccessBtn,
  SuccessBtnMobile,
  Townhouse,
  Trust,
  Upgrade,
  UploadApprovalNotice,
  Villa,
  WithinMonths,
  WithinWeeks,
  Yesterday,
} from './Icons';
import {
  Calendar,
  ChatLoading,
  PriceBracketChat,
  PropertyWorthChat,
} from './ChatComponent';
import { Help, HelpOutline } from '@mui/icons-material';
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min';
import CountSelector from './Countselector';
import Loading from 'assets/images/loading.png';
import { RayWhite } from 'modules/private/BuyerDashboard/BuyerChat';

// chat question component
const ChatQuestion = ({ question }) => {
  const only450screen = useMediaQuery((theme) => theme.breakpoints.down(450));

  return (
    <Stack
      direction={'row'}
      justifyContent={'center'}
      alignItems={'flex-end'}
      gap={'20px'}
      minWidth="45%"
      maxWidth="90%"
    >
      <Box
        sx={{
          background: 'rgba(0, 101, 252, 1)',
          width: '90%',
          borderRadius: '50px',
          zIndex: '100',
        }}
      >
        <Typography
          component={'p'}
          sx={{
            color: 'white',
            fontSize: { xs: '13px', sm: '15px', md: '20px' },
            fontFamily: 'Poppins',
            fontWeight: '400',
            textAlign: 'left',
            padding: '20px',
          }}
        >
          {question}
        </Typography>
      </Box>
      <Box
        sx={{
          height: only450screen ? '40px' : '56px',
          width: only450screen ? '40px' : '56px',
          background: 'white',
          borderRadius: '50%',
          bottom: '-30px',
          right: '-30px',
          color: 'white',
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          boxShadow: '0 2px 6px rgba(0,0,0,0.12)', // 👈 light shadow
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontFamily: 'Poppins',
            fontSize: { xs: '14px', sm: '16px', md: '18px' },
          }}
        >
          <img
            alt="Logo"
            src={Loading}
            style={{ height: '40px', width: '40px' }}
          />
        </Typography>
      </Box>
    </Stack>
  );
};

const ChatOptions = ({ question, handleInputChange, propertyType }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));

  const icons = [
    { pt_Id: 1, icon: ApartmentUnit },
    { pt_Id: 2, icon: Townhouse },
    { pt_Id: 3, icon: House },
    { pt_Id: 4, icon: Villa },
    { pt_Id: 5, icon: RetirementLiving },
    { pt_Id: 7, icon: Land },
    { pt_Id: 8, icon: Acreage },
    { pt_Id: 9, icon: Rural },
    { pt_Id: 10, icon: BlockOfApartments },
  ];

  const options1 = [
    { label: '1-3 months', value: '1-3 months', icon: CalendarIcon },
    { label: '3-6 months', value: '3-6 months', icon: CalendarIcon },
    { label: '6-12 months', value: '6-12 months', icon: CalendarIcon },
  ];

  const options2 = [
    { label: 'yesterday', value: 'yesterday', icon: Yesterday },
    { label: 'within weeks', value: 'within weeks', icon: WithinWeeks },
    { label: 'within months', value: 'within months', icon: WithinMonths },
    {
      label: 'just staying active in market/ anytime',
      value: 'just staying active in market/ anytime',
      icon: AlwaysActive,
    },
  ];

  const options3 = [
    { label: 'Self', value: 'Self', icon: Self },
    { label: 'A relative', value: 'A relative', icon: Relative },
    { label: 'Friend', value: 'Friend', icon: Friend },
    { label: 'Company', value: 'Company', icon: Company },
    { label: 'Trust', value: 'Trust', icon: Trust },
  ];

  const options4 = [
    { label: 'Occupy', value: 'Occupy', icon: Floorplan },
    { label: 'Invest', value: 'Invest', icon: Location },
  ];

  const options5 = [
    { label: 'Downsize', value: 'Downsize', icon: Downsize },
    { label: 'Upgrade', value: 'Upgrade', icon: Upgrade },
    { label: 'First Home', value: 'First Home', icon: FirstHome },
    { label: 'Family change', value: 'Family change', icon: FamilyChange },
  ];

  const options6 = propertyType.map((item) => ({
    label: item?.pt_propertyType,
    value: item?.pt_propertyTypeCode,
    icon: icons.find((icon) => icon.pt_Id === item?.pt_Id)?.icon || null,
  }));

  const options7 = [
    {
      label: 'Follow up with which bank',
      value: 'Follow up with which bank',
      icon: FollowUpBank,
    },
    {
      label: 'Upload notice of approval',
      value: 'Upload notice of approval',
      icon: UploadApprovalNotice,
    },
  ];

  useEffect(() => {
    setOptions(
      question?.questionCode === 'BQ007'
        ? options1
        : question?.questionCode === 'BQ010'
        ? options2
        : question?.questionCode === 'BQ011'
        ? options3
        : question?.questionCode === 'BQ012'
        ? options4
        : question?.questionCode === 'BQ013'
        ? options5
        : question?.questionCode === 'BQ024'
        ? options7
        : question?.questionCode === 'BQ017'
        ? options6
        : []
    );
  }, [question, propertyType]);

  return (
    <Box
      sx={{
        width: { xs: 'auto', sm: '300px', md: '500px' },
        padding: '5px 10px',
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Poppins',
          fontSize: matchessm ? '12px' : '18px',
          fontWeight: '300',
          textAlign: 'center',
          display: 'block',
          p: '20px 0',
        }}
      >
        Please select
      </Typography>
      <Grid
        container
        spacing={{ xs: 2, sm: 0, md: 0 }}
        sx={{
          display: 'flex',
          alignItems: 'end',
          justifyContent: 'space-around',
        }}
        md={12}
      >
        {options?.map((item, index) => {
          const IconComponent = item?.icon;
          const isWideOption = item.label.length > 25;
          return (
            <Grid
              key={index}
              item
              md={isWideOption ? 8 : 4}
              sm={isWideOption ? 8 : 4}
              xs={isWideOption ? 8 : 4}
              sx={{ textAlign: 'center' }}
            >
              <IconButton
                disableTouchRipple
                disableFocusRipple
                disableRipple
                onClick={() => handleInputChange(item.value)}
                sx={{ position: 'relative', padding: '0px' }}
              >
                <Stack
                  direction={'column'}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                  sx={{
                    width: matchessm ? '100%' : '150px',
                    height: !matchessm && '95px',
                  }}
                >
                  <IconComponent
                    value={question?.questionAnswer?.includes(item?.label)}
                  />
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: matchessm ? '10px' : '13px',
                      fontWeight: '300',
                      textAlign: 'center',
                      width: isWideOption ? 140 : 105,
                      whiteSpace: 'normal',
                      wordWrap: 'break-word',
                    }}
                  >
                    {item.label}
                  </Typography>
                </Stack>
                {question?.questionAnswer?.includes(item?.value) && (
                  <Box sx={{ position: 'absolute', top: '0', right: '0' }}>
                    <SelectIcon />
                  </Box>
                )}
              </IconButton>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

const BuyerChats = () => {
  const history = useHistory();
  const location = useLocation();

  // final thanks Screen trigger
  const [finalTrigger, setFinalTrigger] = useState(false);
  const [questionData, setQuestionData] = useState([]);
  const [infopopup, setInfopopup] = useState(false);
  const anchorRef = useRef(null);
  const [progressCount, setProgressCount] = useState('');
  const [errors, setErrors] = useState(false);
  const [selectedBox, setSelectedBox] = useState(null);
  const [propertyType, setPropertyType] = useState([]);
  const { propertyId, propertyIds } = location.state || {};

  // chat loading
  const [loading, setLoading] = React.useState(false);

  // current question validations
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  useEffect(() => {
    const data = JSON.parse(localStorage.getItem('questions')) ?? {};
    if (data && data?.length) {
      setCurrentQuestionIndex(0);
      setQuestionData(data);
    }
    Profilecount();
  }, []);

  useEffect(() => {
    setSelectedBox(null);
  }, [currentQuestionIndex]);

  const Profilecount = () => {
    getApiCall('buyer/getDashboardCount')
      .then((res) => {
        localStorage.setItem('dashboardCount', JSON.stringify(res?.data));
        setProgressCount(res?.data?.profileSurvey);
      })
      .catch((err) => console.error('Error fetching dashboard count:', err));
  };

  const handleChatReview = async (buyerQuestionData, nextStep) => {
    if (currentQuestionIndex == questionData?.length - 1) {
      setCurrentQuestionIndex(null);
      setFinalTrigger(true);
      setTimeout(() => {
        if (propertyId) {
          history.replace({
            pathname: `market/${propertyId}`,
            state: { propertyIds },
          });
        } else {
          history.goBack();
        }
      }, 2000);
    } else {
      setCurrentQuestionIndex(nextStep);
    }
    await postApiCall(BUYER_SAVEQUESTION, buyerQuestionData)
      .then((res) => {
        getApiCall(`${BUYER_GETQUESTION}/0`).then((res) => {
          if (res?.data?.status == 1) {
            const result = res?.data?.buyerQuestions.filter((value) => {
              if (value.questionAnswer != null) {
                return value.questionAnswer == '';
              }
            });
            localStorage.setItem('questions', JSON.stringify(result));
          }
        });
      })
      .catch((err) => console.error('Error posting question:', err));

    await Profilecount();
  };

  useEffect(() => {
    getApiCall(ADD_PROPERTY_TYPELIST).then((res) => {
      setPropertyType(res?.data?.propertyTypeList);
    });
  }, []);

  const handleNext = () => {
    if (currentQuestionIndex <= questionData?.length - 1) {
      if (
        questionData[currentQuestionIndex]?.questionCode === 'BQ008' &&
        !questionData[currentQuestionIndex]?.questionAnswer
      ) {
        setErrors(true);
        return;
      } else {
        setErrors(false);
      }

      const today = new Date().toISOString().split('T')[0];

      if (
        questionData[currentQuestionIndex]?.questionCode === 'BQ008' &&
        questionData[currentQuestionIndex]?.questionAnswer === today
      ) {
        const buyerQuestionData = {
          buyerQuestionData: [
            {
              questionId: questionData[currentQuestionIndex]?.questionId,
              questionCode: questionData[currentQuestionIndex]?.questionCode,
              questionValue: questionData[currentQuestionIndex]?.questionValue,
              questionAnswer:
                questionData[currentQuestionIndex]?.questionAnswer,
              questionIsSkiped: questionData[currentQuestionIndex]
                ?.questionAnswer
                ? 0
                : 1,
              propertyId: 0,
            },
            {
              questionId: questionData[currentQuestionIndex + 1]?.questionId,
              questionCode: 'BQ009',
              questionValue:
                questionData[currentQuestionIndex + 1]?.questionValue,
              questionAnswer: 'No',
              questionIsSkiped: questionData[currentQuestionIndex + 1]
                ?.questionAnswer
                ? 1
                : 0,
              propertyId: 0,
            },
            {
              questionId: questionData[currentQuestionIndex + 2]?.questionId,
              questionCode: 'BQ010',
              questionValue:
                questionData[currentQuestionIndex + 2]?.questionValue,
              questionAnswer: 'No',
              questionIsSkiped: questionData[currentQuestionIndex + 2]
                ?.questionAnswer
                ? 1
                : 0,
              propertyId: 0,
            },
          ],
        };
        const nextStep = currentQuestionIndex + 3;
        handleChatReview(buyerQuestionData, nextStep);
        return;
      }

      if (
        questionData[currentQuestionIndex]?.questionCode === 'BQ008' &&
        questionData[currentQuestionIndex]?.questionAnswer < today
      ) {
        const buyerQuestionData = {
          buyerQuestionData: [
            {
              questionId: questionData[currentQuestionIndex]?.questionId,
              questionCode: questionData[currentQuestionIndex]?.questionCode,
              questionValue: questionData[currentQuestionIndex]?.questionValue,
              questionAnswer:
                questionData[currentQuestionIndex]?.questionAnswer,
              questionIsSkiped: questionData[currentQuestionIndex]
                ?.questionAnswer
                ? 0
                : 1,
              propertyId: 0,
            },
          ],
        };
        const nextStep = currentQuestionIndex + 1;
        handleChatReview(buyerQuestionData, nextStep);
        return;
      }

      if (
        questionData[currentQuestionIndex]?.questionCode === 'BQ012' &&
        questionData[currentQuestionIndex]?.questionAnswer === 'Occupy' &&
        questionData?.find((q) => q.questionCode === 'BQ006')
          ?.questionAnswer === 'No'
      ) {
        const buyerQuestionData = {
          buyerQuestionData: [
            {
              questionId: questionData[currentQuestionIndex]?.questionId,
              questionCode: questionData[currentQuestionIndex]?.questionCode,
              questionValue: questionData[currentQuestionIndex]?.questionValue,
              questionAnswer:
                questionData[currentQuestionIndex]?.questionAnswer,
              questionIsSkiped: questionData[currentQuestionIndex]
                ?.questionAnswer
                ? 0
                : 1,
              propertyId: 0,
            },
          ],
        };
        const nextStep = currentQuestionIndex + 1;
        handleChatReview(buyerQuestionData, nextStep);
        return;
      }

      if (
        questionData[currentQuestionIndex]?.questionCode === 'BQ012' &&
        questionData[currentQuestionIndex]?.questionAnswer === 'Occupy' &&
        questionData?.find((q) => q.questionCode === 'BQ006')
          ?.questionAnswer === 'Yes'
      ) {
        const buyerQuestionData = {
          buyerQuestionData: [
            {
              questionId: questionData[currentQuestionIndex]?.questionId,
              questionCode: questionData[currentQuestionIndex]?.questionCode,
              questionValue: questionData[currentQuestionIndex]?.questionValue,
              questionAnswer:
                questionData[currentQuestionIndex]?.questionAnswer,
              questionIsSkiped: questionData[currentQuestionIndex]
                ?.questionAnswer
                ? 0
                : 1,
              propertyId: 0,
            },
            {
              questionId: questionData[currentQuestionIndex + 1]?.questionId,
              questionCode: 'BQ013',
              questionValue:
                questionData[currentQuestionIndex + 1]?.questionValue,
              questionAnswer: 'No',
              questionIsSkiped: 0,
              propertyId: 0,
            },
          ],
        };
        const nextStep = currentQuestionIndex + 2;
        handleChatReview(buyerQuestionData, nextStep);
        return;
      }

      if (
        questionData[currentQuestionIndex]?.questionCode === 'BQ012' &&
        questionData[currentQuestionIndex]?.questionAnswer === 'Invest'
      ) {
        const buyerQuestionData = {
          buyerQuestionData: [
            {
              questionId: questionData[currentQuestionIndex]?.questionId,
              questionCode: questionData[currentQuestionIndex]?.questionCode,
              questionValue: questionData[currentQuestionIndex]?.questionValue,
              questionAnswer:
                questionData[currentQuestionIndex]?.questionAnswer,
              questionIsSkiped: questionData[currentQuestionIndex]
                ?.questionAnswer
                ? 0
                : 1,
              propertyId: 0,
            },
            {
              questionId: questionData[currentQuestionIndex + 1]?.questionId,
              questionCode: 'BQ013',
              questionValue:
                questionData[currentQuestionIndex + 1]?.questionValue,
              questionAnswer: 'No',
              questionIsSkiped: 0,
              propertyId: 0,
            },
          ],
        };
        const nextStep = currentQuestionIndex + 2;
        handleChatReview(buyerQuestionData, nextStep);
        return;
      }

      if (
        questionData[currentQuestionIndex]?.questionCode === 'BQ014' &&
        questionData[currentQuestionIndex]?.questionAnswer === 'Yes'
      ) {
        const buyerQuestionData = {
          buyerQuestionData: [
            {
              questionId: questionData[currentQuestionIndex]?.questionId,
              questionCode: questionData[currentQuestionIndex]?.questionCode,
              questionValue: questionData[currentQuestionIndex]?.questionValue,
              questionAnswer:
                questionData[currentQuestionIndex]?.questionAnswer,
              questionIsSkiped: questionData[currentQuestionIndex]
                ?.questionAnswer
                ? 0
                : 1,
              propertyId: 0,
            },
          ],
        };
        const nextStep = currentQuestionIndex + 1;
        handleChatReview(buyerQuestionData, nextStep);
        return;
      }

      if (
        questionData[currentQuestionIndex]?.questionCode === 'BQ014' &&
        questionData[currentQuestionIndex]?.questionAnswer === 'No'
      ) {
        const buyerQuestionData = {
          buyerQuestionData: [
            {
              questionId: questionData[currentQuestionIndex]?.questionId,
              questionCode: questionData[currentQuestionIndex]?.questionCode,
              questionValue: questionData[currentQuestionIndex]?.questionValue,
              questionAnswer:
                questionData[currentQuestionIndex]?.questionAnswer,
              questionIsSkiped: questionData[currentQuestionIndex]
                ?.questionAnswer
                ? 0
                : 1,
              propertyId: 0,
            },
            {
              questionId: questionData[currentQuestionIndex + 1]?.questionId,
              questionCode: 'BQ015',
              questionValue:
                questionData[currentQuestionIndex + 1]?.questionValue,
              questionAnswer: 'No',
              questionIsSkiped: questionData[currentQuestionIndex + 1]
                ?.questionAnswer
                ? 1
                : 0,
              propertyId: 0,
            },
            {
              questionId: questionData[currentQuestionIndex + 2]?.questionId,
              questionCode: 'BQ016',
              questionValue:
                questionData[currentQuestionIndex + 2]?.questionValue,
              questionAnswer: 'No',
              questionIsSkiped: questionData[currentQuestionIndex + 2]
                ?.questionAnswer
                ? 1
                : 0,
              propertyId: 0,
            },
          ],
        };
        const nextStep = currentQuestionIndex + 3;
        handleChatReview(buyerQuestionData, nextStep);
        return;
      }

      if (
        questionData[currentQuestionIndex]?.questionCode === 'BQ015' &&
        questionData[currentQuestionIndex]?.questionAnswer === 'Yes'
      ) {
        const buyerQuestionData = {
          buyerQuestionData: [
            {
              questionId: questionData[currentQuestionIndex]?.questionId,
              questionCode: questionData[currentQuestionIndex]?.questionCode,
              questionValue: questionData[currentQuestionIndex]?.questionValue,
              questionAnswer:
                questionData[currentQuestionIndex]?.questionAnswer,
              questionIsSkiped: questionData[currentQuestionIndex]
                ?.questionAnswer
                ? 0
                : 1,
              propertyId: 0,
            },
          ],
        };
        const nextStep = currentQuestionIndex + 1;
        handleChatReview(buyerQuestionData, nextStep);
        return;
      }

      if (
        questionData[currentQuestionIndex]?.questionCode === 'BQ015' &&
        questionData[currentQuestionIndex]?.questionAnswer === 'No'
      ) {
        const buyerQuestionData = {
          buyerQuestionData: [
            {
              questionId: questionData[currentQuestionIndex]?.questionId,
              questionCode: questionData[currentQuestionIndex]?.questionCode,
              questionValue: questionData[currentQuestionIndex]?.questionValue,
              questionAnswer:
                questionData[currentQuestionIndex]?.questionAnswer,
              questionIsSkiped: questionData[currentQuestionIndex]
                ?.questionAnswer
                ? 0
                : 1,
              propertyId: 0,
            },
            {
              questionId: questionData[currentQuestionIndex + 1]?.questionId,
              questionCode: 'BQ016',
              questionValue:
                questionData[currentQuestionIndex + 1]?.questionValue,
              questionAnswer: 'No',
              questionIsSkiped: questionData[currentQuestionIndex + 1]
                ?.questionAnswer
                ? 1
                : 0,
              propertyId: 0,
            },
          ],
        };
        const nextStep = currentQuestionIndex + 2;
        handleChatReview(buyerQuestionData, nextStep);
        return;
      }

      if (questionData[currentQuestionIndex]?.questionCode === 'BQ019') {
        const buyerQuestionData = {
          buyerQuestionData: [
            {
              questionId: questionData[currentQuestionIndex]?.questionId,
              questionCode: questionData[currentQuestionIndex]?.questionCode,
              questionValue: questionData[currentQuestionIndex]?.questionValue,
              questionAnswer: questionData[
                currentQuestionIndex
              ]?.questionAnswer.map(
                (i) => questionData[currentQuestionIndex]?.questionAnswer[i] + 1
              ),
              questionIsSkiped: questionData[currentQuestionIndex]
                ?.questionAnswer
                ? 0
                : 1,
              propertyId: 0,
            },
          ],
        };
        const nextStep = currentQuestionIndex + 1;
        handleChatReview(buyerQuestionData, nextStep);
        return;
      }

      const buyerQuestionData = {
        buyerQuestionData: [
          {
            questionId: questionData[currentQuestionIndex]?.questionId,
            questionCode: questionData[currentQuestionIndex]?.questionCode,
            questionValue: questionData[currentQuestionIndex]?.questionValue,
            questionAnswer: questionData[currentQuestionIndex]?.questionAnswer,
            questionIsSkiped: questionData[currentQuestionIndex]?.questionAnswer
              ? 0
              : 1,
            propertyId: 0,
          },
        ],
      };

      const nextStep = currentQuestionIndex + 1;
      handleChatReview(buyerQuestionData, nextStep);
    } else {
      setCurrentQuestionIndex(null);
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        setFinalTrigger(true);
      }, 2000);
    }
  };

  const handleInputChange = (value) => {
    setSelectedBox(value);
    const updatedQuestions = [...questionData];
    if (updatedQuestions[currentQuestionIndex]) {
      updatedQuestions[currentQuestionIndex].questionAnswer = value;
    }
    setQuestionData(updatedQuestions);
  };

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  const ProgressWithGradientAndLabel = ({ value }) => {
    return (
      <Box sx={{ position: 'relative', width: '100%' }}>
        <LinearProgress
          variant="determinate"
          value={value}
          sx={{
            height: matchessm ? 15 : 30,
            backgroundColor: '#e0e0e0',
            '& .MuiLinearProgress-bar': {
              background: 'linear-gradient(90deg, #6C2AD2 0%, #0BA8DA 100%)',
            },
          }}
        />
        <Typography
          variant="body2"
          sx={{
            position: 'absolute',
            top: 0,
            left:
              value < 10 && matchessm ? `calc(${value}% + 30px)` : `${value}%`,
            transform: 'translateX(-100%)',
            color: '#fff',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            fontWeight: 'bold',
            pr: 1,
            fontSize: matchessm ? '10px' : '18px',
          }}
        >
          {`${Math.round(value)}%`}
        </Typography>
      </Box>
    );
  };

  return (
    <>
      <Box
        sx={{
          width: '100%',
          height: '100%',
          position: 'relative',
          backgroundColor: '#fff',
        }}
      >
        <DialogTitle sx={{ padding: 0 }}>
          <Box sx={{ width: '100%', paddingY: matchessm ? 2 : 3 }}>
            <ProgressWithGradientAndLabel value={progressCount} />
          </Box>
          {!finalTrigger && (
            <ClickAwayListener
              onClickAway={() => {
                setInfopopup(false);
              }}
            >
              <Box
                sx={{
                  position: 'relative',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '10px',
                  mt: matchessm ? '0px' : '20px',
                }}
              >
                <Typography
                  style={{
                    color: 'rgba(30, 30, 30, 1)',
                    fontFamily: 'Poppins',
                    fontWeight: '600',
                  }}
                  sx={{
                    fontSize: {
                      xs: '16px',
                      sm: '20px',
                      md: '24px',
                      lg: '26px',
                      xl: '30px',
                    },
                  }}
                >
                  {/* {address ?? ""} */}
                  Configure your profile
                  <IconButton
                    ref={anchorRef}
                    sx={{ mb: '25px' }}
                    onClick={() => setInfopopup((prev) => !prev)}
                  >
                    <HelpOutline sx={{ color: '#0D0D0D' }} />
                  </IconButton>
                </Typography>

                <Popper
                  open={infopopup}
                  anchorEl={anchorRef.current}
                  placement={matchessm ? 'left' : 'right'}
                  disablePortal
                >
                  <Paper
                    sx={{
                      p: matchessm ? 1 : 2,
                      maxWidth: matchessm ? 240 : 500,
                      bgcolor: 'white',
                      boxShadow: 3,
                      borderRadius: 2,
                      fontFamily: 'Poppins',
                      zIndex: 5,
                      display: 'flex',
                    }}
                  >
                    <Typography
                      sx={{ paddingRight: matchessm ? '5px' : '10px' }}
                    >
                      <Help
                        fontSize={matchessm ? 'small' : 'large'}
                        sx={{
                          borderRadius: '50%',
                          color: '#6C2AD2',
                          backgroundColor: 'white',
                        }}
                      />
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: matchessm ? '8px' : '14px',
                        fontWeight: 300,
                        fontFamily: 'Poppins',
                        color: '#000000',
                      }}
                    >
                      Help us, help you find the perfect property.
                      <br />
                      <br />
                      Answer a few quick questions so we can match you with the
                      right on and off-market properties.
                      <br />
                      <br />
                      No pressure—you can finish your full profile anytime.
                    </Typography>
                  </Paper>
                </Popper>
              </Box>
            </ClickAwayListener>
          )}
        </DialogTitle>

        <DialogContent
          sx={{
            mt: matchessm ? '5px' : '50px',
            padding: '0px',
            height: matchessm ? '70%' : '60%',
          }}
        >
          <Stack
            direction={'column'}
            justifyContent={'center'}
            alignItems={'center'}
            gap={matchessm ? '0px' : '25px'}
          >
            <>
              <>
                {!loading &&
                  (questionData[currentQuestionIndex]?.questionCode ===
                    'BQ018' ||
                    questionData[currentQuestionIndex]?.questionCode ===
                      'BQ019' ||
                    questionData[currentQuestionIndex]?.questionCode ===
                      'BQ020') && (
                    <>
                      <ChatQuestion
                        question={
                          questionData[currentQuestionIndex]?.questionValue
                        }
                      />
                      <Stack direction="row">
                        <Typography
                          sx={{
                            fontFamily: 'Poppins',
                            fontSize: matchessm ? '12px' : '18px',
                            fontWeight: '300',
                            textAlign: 'center',
                            display: 'block',
                            p: '20px 0px',
                            mt: { xs: 3, sm: 3, md: 3 },
                            mb: { xs: 3, sm: 3, md: 3 },
                          }}
                        ></Typography>
                      </Stack>
                      <Stack spacing={3} width={matchessm ? '100%' : '30%'}>
                        <CountSelector
                          label={
                            questionData[currentQuestionIndex]?.questionCode ===
                            'BQ018'
                              ? 'bed'
                              : questionData[currentQuestionIndex]
                                  ?.questionCode === 'BQ019'
                              ? 'bath'
                              : 'park'
                          }
                          onChange={handleInputChange}
                          value={
                            questionData[currentQuestionIndex]?.questionAnswer
                          }
                        />
                      </Stack>
                    </>
                  )}
                {!loading &&
                  (questionData[currentQuestionIndex]?.questionCode ===
                    'BQ007' ||
                    questionData[currentQuestionIndex]?.questionCode ===
                      'BQ010' ||
                    questionData[currentQuestionIndex]?.questionCode ===
                      'BQ011' ||
                    questionData[currentQuestionIndex]?.questionCode ===
                      'BQ012' ||
                    questionData[currentQuestionIndex]?.questionCode ===
                      'BQ013' ||
                    questionData[currentQuestionIndex]?.questionCode ===
                      'BQ024' ||
                    questionData[currentQuestionIndex]?.questionCode ===
                      'BQ017') && (
                    <>
                      <ChatQuestion
                        question={
                          questionData[currentQuestionIndex]?.questionValue
                        }
                      />
                      <ChatOptions
                        handleInputChange={handleInputChange}
                        question={questionData[currentQuestionIndex]}
                        propertyType={propertyType}
                      />
                    </>
                  )}
                {!loading &&
                  (questionData[currentQuestionIndex]?.questionCode ===
                    'BQ006' ||
                    questionData[currentQuestionIndex]?.questionCode ===
                      'BQ009' ||
                    questionData[currentQuestionIndex]?.questionCode ===
                      'BQ014' ||
                    questionData[currentQuestionIndex]?.questionCode ===
                      'BQ015' ||
                    questionData[currentQuestionIndex]?.questionCode ===
                      'BQ016' ||
                    questionData[currentQuestionIndex]?.questionCode ===
                      'BQ021') && (
                    <>
                      <ChatQuestion
                        question={
                          questionData[currentQuestionIndex]?.questionValue
                        }
                      />
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          gap: onlySmallScreen ? '10%' : '100%',
                          mt: '6%',
                        }}
                      >
                        <IconButton
                          disableTouchRipple
                          disableFocusRipple
                          disableRipple
                          onClick={() => {
                            handleInputChange('Yes');
                            handleNext();
                          }}
                        >
                          {onlySmallScreen ? (
                            <SuccessBtnMobile />
                          ) : (
                            <SuccessBtn />
                          )}
                        </IconButton>
                        <IconButton
                          disableTouchRipple
                          disableFocusRipple
                          disableRipple
                          onClick={() => {
                            handleInputChange('No');
                            handleNext();
                          }}
                        >
                          {onlySmallScreen ? (
                            <CancelBtnMobile />
                          ) : (
                            <CancelBtn />
                          )}
                        </IconButton>
                      </Box>
                    </>
                  )}
                {!loading &&
                  questionData[currentQuestionIndex]?.questionCode ===
                    'BQ008' && (
                    <>
                      <ChatQuestion
                        question={
                          questionData[currentQuestionIndex]?.questionValue
                        }
                      />
                      <Stack
                        direction={'row'}
                        sx={{ minWidth: '30%', maxWidth: '60%', mt: '6%' }}
                      >
                        <Calendar
                          onDateSelect={handleInputChange}
                          errors={errors}
                          setErrors={setErrors}
                          value={
                            questionData[currentQuestionIndex]?.questionAnswer
                          }
                          disablefuture={true}
                          disablepast={false}
                        />
                      </Stack>
                    </>
                  )}
                {!loading &&
                  questionData[currentQuestionIndex]?.questionCode ===
                    'BQ022' && (
                    <>
                      <ChatQuestion
                        question={
                          questionData[currentQuestionIndex]?.questionValue
                        }
                      />
                      <Stack
                        direction={'row'}
                        justifyContent={'center'}
                        height={200}
                        alignItems={'center'}
                        width={{ xs: '90%', sm: '70%', md: '40%' }}
                      >
                        <PriceBracketChat
                          handleInputChange={handleInputChange}
                          value={
                            questionData[currentQuestionIndex]?.questionAnswer
                          }
                        />
                      </Stack>
                    </>
                  )}
                {!loading &&
                  questionData[currentQuestionIndex]?.questionCode ===
                    'BQ023' && (
                    <>
                      <ChatQuestion
                        question={
                          questionData[currentQuestionIndex]?.questionValue
                        }
                      />
                      <Stack
                        direction={'row'}
                        justifyContent={'center'}
                        height={200}
                        alignItems={'center'}
                        width={{ xs: '90%', sm: '70%', md: '45%' }}
                      >
                        <PropertyWorthChat
                          handleInputChange={handleInputChange}
                          value={
                            questionData[currentQuestionIndex]
                              ?.questionAnswer != 0
                              ? questionData[currentQuestionIndex]
                                  ?.questionAnswer
                              : 2000000
                          }
                        />
                      </Stack>
                    </>
                  )}
              </>
              {finalTrigger && (
                <>
                  <Box>
                    <Typography
                      style={{
                        color: 'rgb(154, 188, 102)',
                        textAlign: 'center',
                        fontFamily: 'poppins',
                        fontSize: matchessm ? '16px' : '24px',
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      You're one step closer to find your dream property !
                    </Typography>
                  </Box>

                  <img
                    src={successgif}
                    alt="successgif"
                    style={{
                      width: matchessm ? '100%' : '700px',
                    }}
                  />
                </>
              )}

              {loading && (
                <ChatLoading value={'BU'} agentProfileImage={Loading} />
              )}
            </>
          </Stack>
        </DialogContent>

        {!finalTrigger && (
          <Box
            sx={{
              width: '100%',
              position: 'relative',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Stack
              direction={'row'}
              alignItems={'center'}
              justifyContent={'right'}
              paddingLeft={matchessm ? '45%' : '40%'}
              position={'absolute'}
              bottom={'20%'}
            >
              {currentQuestionIndex != 0 && (
                <IconButton
                  sx={{ fontSize: '16px', marginRight: '5px' }}
                  onClick={() => {
                    if (
                      questionData[currentQuestionIndex]?.questionCode ===
                      'BQ014'
                    ) {
                      setCurrentQuestionIndex(currentQuestionIndex - 2);
                    } else if (
                      questionData[currentQuestionIndex]?.questionCode ===
                      'BQ017'
                    ) {
                      setCurrentQuestionIndex(currentQuestionIndex - 3);
                    } else {
                      setCurrentQuestionIndex(currentQuestionIndex - 1);
                    }
                  }}
                >
                  Back
                </IconButton>
              )}
              {!(
                questionData[currentQuestionIndex]?.questionCode === 'BQ006' ||
                questionData[currentQuestionIndex]?.questionCode === 'BQ009' ||
                questionData[currentQuestionIndex]?.questionCode === 'BQ014' ||
                questionData[currentQuestionIndex]?.questionCode === 'BQ015' ||
                questionData[currentQuestionIndex]?.questionCode === 'BQ016' ||
                questionData[currentQuestionIndex]?.questionCode === 'BQ021'
              ) && (
                <Button
                  variant="contained"
                  disabled={
                    questionData[currentQuestionIndex]?.questionAnswer ==
                      null ||
                    questionData[currentQuestionIndex]?.questionAnswer == ''
                  }
                  disableElevation
                  disableFocusRipple
                  disableRipple
                  disableTouchRipple
                  onClick={handleNext}
                  sx={{
                    color: 'white',
                    background: 'rgba(76, 164, 214, 1) !important',
                    borderRadius: '20px',
                    width: { xs: 80, sm: 144, md: 144 },
                    textTransform: 'capitalize',
                    fontWeight: 'bold',
                  }}
                  color="primary"
                >
                  Next
                </Button>
              )}
            </Stack>
          </Box>
        )}

        <DialogActions
          sx={{
            display: 'flex',
            marginBottom: '10px',
            justifyContent: 'space-between',
            position: 'absolute',
            bottom: '0px',
          }}
        >
          <Box
            sx={{ padding: '20px', cursor: 'pointer' }}
            onClick={() => {
              localStorage.setItem('issurveyskipped', true);
              if (propertyId) {
                history.push({
                  pathname: `market/${propertyId}`,
                  state: { propertyIds },
                });
              } else {
                history.goBack();
              }
            }}
          >
            {!finalTrigger && (
              <Typography
                component={'div'}
                sx={{
                  fontFamily: 'Poppins',
                  fontWeight: '500',
                  fontSize: matchessm ? '12px' : '20px',
                  color: '#C4C4C4',
                }}
              >
                Skip Survey
              </Typography>
            )}
          </Box>
        </DialogActions>
      </Box>
    </>
  );
};

export default BuyerChats;
